import { Animated } from 'react-native';
import styled from 'styled-components/native';

import { neutralGrey } from '../../../constants/color';

export default {
  Cover: styled(Animated.View)<{ bgColor?: string; height: number }>`
    background-color: ${({ bgColor }) => bgColor || 'transparent'};
    width: 100%;
    height: ${({ height }) => height}px;
    position: absolute;
    top: 0;
    left: 0;
  `,
  Placeholder: styled(Animated.View)<{ width?: number; height?: number }>`
    width: ${({ width }) => width || 0}px;
    height: ${({ height }) => height || 0}px;
    background-color: ${neutralGrey};
  `,
};
